import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { copyImportForm } from 'redux/product'
import { Form, Header } from 'semantic-ui-react'

const i18nkey = 'admin.product.generic.'

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ copyImportForm }, dispatch)
}

class ProductCopy extends React.Component {
  constructor(props) {
    super(props)
    this.state = { articleNumber: '' }
  }

  render() {
    return (
      <div>
        <Header as="h3" dividing content={I18n.t(i18nkey + 'copy_product')} />
        <Form.Group>
          <Form.Input
            placeholder={I18n.t(i18nkey + 'article_number')}
            value={this.state.articleNumber}
            onChange={(event, comp) =>
              this.setState({ articleNumber: comp.value })
            }
          />
          <Form.Button content={I18n.t(i18nkey + 'copy')} onClick={() => this.props.copyImportForm(this.state.articleNumber)}/>
        </Form.Group>
      </div>
    )
  }
}
ProductCopy = connect(undefined, mapDispatchToProps)(ProductCopy)
export default ProductCopy



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductCopy.jsx